import { SlideOutWindowOption } from './slideOutWindow.types';

export const SLIDE_OUT_WIDTH = {
  SMALL: '380px',
  MEDIUM: '550px',
  LARGE: '900px',
};

export const DEFAULT_OPTION: SlideOutWindowOption = {
  direction: 'right',
  sizeType: 'MEDIUM',
  headerActions: ['open', 'close'],
  hasDimLayer: false,
  minWidth: '0',
  minHeight: '0',
  bodyYScroll: 'auto',
  top: '0px',
  translateX: '0px',
  hasExpand: true,
};

// slideOutWindow 영역 외 클릭 시 창 닫기 동작에서 제외할 선택자 목록
export const EXCLUDE_SELECTORS = {
  // 항상 제외할 선택자 목록
  always: [
    '#ev-message-box-modal',
    '#ev-window-modal',
    '#base-custom-tooltip',
    '#ev-grid-filtering-items-modal',
    '#ev-context-menu-modal',
    '#ev-grid-filter-setting-modal',
    '#ev-grid-column-setting-modal',
    '.slide-out',
    '.application-page-load-avg-rank__container',
    '.text-tooltip',
    '.top-list__name--clickable',
    '.common-tooltip',
    '.on-site-alarm',
    '.service-card',
    '.equalizer-chart',
    '.bullet-chart',
    '.ring-bullet-chart',
    '.top-bar-chart-widget-content',
    '.time-series-line-widget__content',
    '.status-summary-card__card-wrapper',
    '[data-radix-popper-content-wrapper]',
    '.fullscreen-wrapper',
    '#popup',
    '.color-palette-button__palette',
    '.modern-grid-body__cell--link',
    '.modern-grid-body__cell-value',
    '.scoreboard-style-1__card',
    '.ratio-bar',
    '.stacked-proportion-bar-chart-widget__content',
    '.exclusive-style1-chart-item',
    '.sub-menu-element.selected',
    '.base-menu-header__slide-button',
    '.close-gnb-wrapper .ev-button',
    '.clickoutside-ignore',
    '.event-alert-grid table',
    '.screen-x-ray-popup',
  ],
  // 영역 중 cursor가 pointer인 경우에만 제외할 선택자 목록
  withCursor: [
    '.hexagon-chart',
    '.cluster-map__main',
    '.object-topology',
    '.transaction-view-summary',
    '.table-body table',
    '.vue-grid-item',
    '.page-call-rank__list',
    '.modern-grid-body__cell-content',
    '.top-value-card__name',
    '.top-range-card__name',
  ],
};
